import React, { PureComponent } from "react";
import moment from "moment-timezone";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, getSentimentColor, intToRGB, hashCode } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);

class EngagementOverTime extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.expandWidget !== this.props.expandWidget ||
            //nextProps.currentChartType !== this.props.currentChartType ||
            nextProps.showLegend !== this.props.showLegend ||
            //nextProps.showLabel !== this.props.showLabel ||
            nextProps.showGridLines !== this.props.showGridLines
            // nextProps.index !== this.props.index
        ) {
            return true;
        }

        return false;
    }

    getOptions = () => {
        //  let data = this.props.data.chartData;
        console.log("hellllo", this.props.data);
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let plotComaprisiondata;

        let plotComaprisiondataCondition =
            this.props.comparisionData && this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length;

        if (plotComaprisiondataCondition && this.props.data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(this.props.data.chartData));

            this.props.comparisionData.chartData.total.forEach((element, ind) => {
                if (plotComaprisiondata.total[ind]) {
                    plotComaprisiondata.total[ind].originalX = plotComaprisiondata.total[ind].x;
                    plotComaprisiondata.total[ind].x = element.x;
                    plotComaprisiondata.Comments[ind].originalX = plotComaprisiondata.Comments[ind].x;
                    plotComaprisiondata.Comments[ind].x = element.x;
                    plotComaprisiondata.Likes[ind].originalX = plotComaprisiondata.Likes[ind].x;
                    plotComaprisiondata.Likes[ind].x = element.x;
                    plotComaprisiondata.Shares[ind].originalX = plotComaprisiondata.Shares[ind].x;
                    plotComaprisiondata.Shares[ind].x = element.x;
                    plotComaprisiondata.Views[ind].originalX = plotComaprisiondata.Views[ind].x;
                    plotComaprisiondata.Views[ind].x = element.x;
                }
            });
        } else {
            if (this.props.comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(this.props.comparisionData.chartData));

                this.props.data &&
                    this.props.data.chartData.total.forEach((element, ind) => {
                        if (plotComaprisiondata.total[ind]) {
                            plotComaprisiondata.total[ind].originalX = plotComaprisiondata.total[ind].x;
                            plotComaprisiondata.total[ind].x = element.x;
                            plotComaprisiondata.Comments[ind].originalX = plotComaprisiondata.Comments[ind].x;
                            plotComaprisiondata.Comments[ind].x = element.x;
                            plotComaprisiondata.Likes[ind].originalX = plotComaprisiondata.Likes[ind].x;
                            plotComaprisiondata.Likes[ind].x = element.x;
                            plotComaprisiondata.Shares[ind].originalX = plotComaprisiondata.Shares[ind].x;
                            plotComaprisiondata.Shares[ind].x = element.x;
                            plotComaprisiondata.Views[ind].originalX = plotComaprisiondata.Views[ind].x;
                            plotComaprisiondata.Views[ind].x = element.x;
                        }
                    });
            }
        }

        let serObj = this.props.comparisionData
            ? [
                  {
                      name: "Total",
                      data:
                          this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length
                              ? plotComaprisiondata.total
                              : this.props.data.chartData.total,
                      color: getSentimentColor("total"),
                      visible: false,
                  },
                  {
                      name: "Total comparisionData",
                      data:
                          this.props.comparisionData.chartData.total.length < this.props.data.chartData.total.length
                              ? plotComaprisiondata.total
                              : this.props.comparisionData.chartData.total,

                      linkedTo: ":previous",
                      color: getSentimentColor("total") + "85",
                      visible: false,
                  },

                  {
                      name: "Comments",
                      // name: `${moment(this.props.data.chartData.date.start_date).format("DD MMM YYYY")} - ${moment(this.props.data.chartData.date.end_date).format("DD MMM YYYY")}`,
                      data:
                          this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length
                              ? plotComaprisiondata.Comments
                              : this.props.data.chartData.Comments,
                      color: intToRGB(hashCode("comment")),
                  },
                  {
                      // name: `${moment(this.props.comparisionData.chartData.date.start_date).format("DD MMM YYYY")} - ${moment(
                      //     this.props.comparisionData.chartData.date.end_date,
                      // ).format("DD MMM YYYY")}`,
                      name: "Comments comparisionData",
                      data:
                          this.props.comparisionData.chartData.total.length < this.props.data.chartData.total.length
                              ? plotComaprisiondata.Comments
                              : this.props.comparisionData.chartData.Comments,

                      linkedTo: ":previous",
                      color: intToRGB(hashCode("comment")) + "85",
                  },

                  {
                      name: "Likes",
                      data:
                          this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length
                              ? plotComaprisiondata.Likes
                              : this.props.data.chartData.Likes,
                      color: intToRGB(hashCode("like")),
                  },
                  {
                      name: "Likes comparisionData",
                      data:
                          this.props.comparisionData.chartData.total.length < this.props.data.chartData.total.length
                              ? plotComaprisiondata.Likes
                              : this.props.comparisionData.chartData.Likes,

                      color: intToRGB(hashCode("like")) + "85",
                      linkedTo: ":previous",
                  },

                  {
                      name: "Shares",
                      data:
                          this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length
                              ? plotComaprisiondata.Shares
                              : this.props.data.chartData.Shares,
                      color: intToRGB(hashCode("share")),
                      visible: false,
                  },

                  {
                      name: "Shares comparisionData",
                      data:
                          this.props.comparisionData.chartData.total.length < this.props.data.chartData.total.length
                              ? plotComaprisiondata.Shares
                              : this.props.comparisionData.chartData.Shares,
                      color: intToRGB(hashCode("share")) + "85",

                      linkedTo: ":previous",
                      visible: false,
                  },
                  {
                      name: "Views",
                      // name: `${moment(this.props.data.chartData.date.start_date).format("DD MMM YYYY")} - ${moment(this.props.data.chartData.date.end_date).format("DD MMM YYYY")}`,
                      data:
                          this.props.comparisionData.chartData.total.length >= this.props.data.chartData.total.length
                              ? plotComaprisiondata.Views
                              : this.props.data.chartData.Views,
                      color: intToRGB(hashCode("views")),
                      visible: false,
                  },
                  {
                      // name: `${moment(this.props.comparisionData.chartData.date.start_date).format("DD MMM YYYY")} - ${moment(
                      //     this.props.comparisionData.chartData.date.end_date,
                      // ).format("DD MMM YYYY")}`,
                      name: "Views comparisionData",
                      data:
                          this.props.comparisionData.chartData.total.length < this.props.data.chartData.total.length
                              ? plotComaprisiondata.Views
                              : this.props.comparisionData.chartData.Views,

                      linkedTo: ":previous",
                      color: intToRGB(hashCode("views")) + "85",
                      visible: false,
                  },
              ]
            : [
                  {
                      name: "Total",
                      data: this.props.data.chartData.total,
                      color: getSentimentColor("total"),
                  },
                  {
                      name: "Comments",
                      data: this.props.data.chartData.Comments,
                      color: intToRGB(hashCode("comment")),
                  },
                  {
                      name: "Likes",
                      data: this.props.data.chartData.Likes,
                      color: intToRGB(hashCode("like")),
                  },
                  {
                      name: "Shares",
                      data: this.props.data.chartData.Shares,
                      color: intToRGB(hashCode("share")),
                  },
                  {
                      name: "Views",
                      data: this.props.data.chartData.Views,
                      color: intToRGB(hashCode("views")),
                  },
              ];

        const optionsOverTime = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    events: {
                        legendItemClick: function () {
                            self.props.legendClick(true);
                        },
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                className: "skiptranslate",
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("85");
                            let secondColorPoint = this.points[0]?.color.endsWith("85");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }
                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>
                          
                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }

                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };

    render() {
        return this.props.expandWidget ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        ) : (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default EngagementOverTime;
